<!-- Interactions -->
<div
  class="surface-0 border-1 border-300 shadow-1 border-round text-sm p-3 flex align-items-center justify-content-between"
  [attr.data-testid]="'migration-header'"
>
  <div [attr.data-testid]="'migration-date-section'">
    @if (!(showSkeleton | async) && clientMigration) {
      <div
        [attr.aria-label]="'migration-date'"
        [innerHTML]="
          'MIGRATION.MIGRATION_DATE'
            | translate
              : { date: clientMigration.created_date | date: 'dd MMM yy' }
        "
      ></div>
    }
    @if (showSkeleton | async) {
      <p-skeleton
        height="1.5rem"
        styleClass="w-10rem"
        [attr.data-testid]="'migration-date-skeleton'"
      />
    }
  </div>
</div>
<!-- Interactions -->

<!-- Card -->
@if (showSkeleton | async) {
  <div
    class="surface-0 p-3 border-1 border-300 shadow-1 border-round text-sm mt-3"
    [attr.data-testid]="'migration-content-skeleton'"
  ></div>
} @else {
  @if (clientMigration && clientMigration!.migration_comments) {
    <div
      class="surface-0 p-3 border-1 border-300 shadow-1 border-round text-sm mt-3"
      [attr.data-testid]="'migration-content'"
      [attr.aria-label]="'migration-comments'"
      [innerHTML]="clientMigration!.migration_comments | markdown"
    ></div>
  } @else {
    <div
      #noDate
      class="surface-0 h-23rem border-1 border-300 shadow-1 border-round text-sm mt-3"
      [attr.data-testid]="'migration-no-data'"
      [attr.aria-label]="'no-migration-data'"
    ></div>
  }
}

<!-- Card -->
